import { abortNavigation, defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import type { RouteLocationNormalized } from 'vue-router'
import { useAuth } from './composables/auth'
import { useAttainConfig } from './composables/config'
import type { UserRole } from './composables/user'

export type AuthMeta = boolean | 'guest'

/**
 * @see https://nuxt.com/docs/guide/directory-structure/middleware
 */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  const config = useAttainConfig()
  const {
    hasRole,
    state: { isLoggedIn },
  } = useAuth()
  const { auth = config.auth, role } = to.meta

  if (auth === false) return
  if (auth === 'guest') {
    if (isLoggedIn) return navigateTo(config.locations.home, { replace: true })
    return
  }
  if (role) return hasRole(role) ? undefined : abortNavigation('Access denied')
  if (isLoggedIn) return

  const redirect = to.path === config.locations.login || to.path.startsWith(`${config.locations.login}/`) || to.path === config.locations.home
    ? undefined
    : to.fullPath
  return navigateTo({ path: config.locations.login, query: { redirect } }, { replace: true })
})

// declare module '#app' { // Seams not working despite the documentation
declare module '../../../node_modules/nuxt/dist/pages/runtime/composables' {
  // this works
  interface PageMeta {
    auth?: AuthMeta
    role?: UserRole | UserRole[]
  }
}
